/* KT · Katlune — apariciones suaves al hacer scroll. Sin librerías. */
(function () {
  'use strict';
  if (window.ktCargado) return;
  window.ktCargado = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enEditor = !!(window.Shopify && window.Shopify.designMode);
  if (enEditor) document.documentElement.classList.add('kt-editor');

  var observador = null;
  function init(ctx) {
    var raiz = ctx || document;
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-kt-stagger]'), function (grupo) {
      var paso = parseInt(grupo.getAttribute('data-kt-stagger'), 10) || 90;
      Array.prototype.forEach.call(grupo.querySelectorAll('[data-kt-reveal]'), function (el, i) {
        el.style.setProperty('--kt-delay', i * paso + 'ms');
      });
    });
    var els = raiz.querySelectorAll('[data-kt-reveal]');
    if (reduce || enEditor || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('kt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('kt-visible'); observador.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }
    Array.prototype.forEach.call(els, function (el) { observador.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
